/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import OwnerAccViewAll from "../../../../containers/Accounts/OwnerAccount/OwnerAccountViewAll";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import LargePopupRedirect from "../../../_utils/CommonPopups/CommonLargePopupRedirect";

const OwnerAccountPopUp = ({
  setTxnPayLoad,
  txnPayLoad,
  setIsNeft,
  setIsImps,
  setIsRtgs,
  setOpenOwner,
  flow,
  TypeAccount,
  BenEnableNextButton,
  onAccountSelect,
  handleButtonClick,
  accountNumber,
  accountnumberstate,
  setaccountnumberstate,
  multiSelect,
  setAccountNumber,
  onClosed,
  setDefaultAccountNumber,
  accountDefaultNumber,
  popType,
  handlePopupClose,
  scheduleIntenralTxn,
  setRefactorAccDetail,
  type,
  setpaymentBox,
  selectedLabelsCreate,
  TypeRTGS,
  currentAccountDetails,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(disableSwitcher());
    return () => {
      dispatch(enableSwitcher());
    };
  }, []);
  const handleButtonClickLocal = (dataItem) => {
    onAccountSelect?.(
      dataItem?.name?.trim(),
      dataItem?.bank_acc_no?.trim(),
      dataItem?.ifsc_code?.trim(),
      dataItem?.id?.trim(),
    );
  };
  const handleButtonClickToUse =
    flow === "ReimbursementRequestMultiFlow" && handleButtonClick
      ? handleButtonClick
      : handleButtonClickLocal;

  const headerTitle = useMemo(() => {
    if (flow === "internalTxn") {
      return "Select destination account";
    }

    if (TypeAccount === "InternalAccountTxn") {
      return "Select owner account";
    }

    return "Select owner account";
  }, [flow, TypeAccount]);

  const headersubtext = useMemo(() => {
    if (flow === "ReimbursementRequestMultiFlow") {
      return "Only accounts with connected banking active are available for selection.";
    }
    if (flow === "internalTxn") {
      return "Only active (pending & approved) accounts are enabled for selection.";
    }

    if (TypeAccount === "InternalAccountTxn" || type === "bulk statement") {
      return "Only accounts with connected banking active are available for selection. Source and destination account cannot be same.";
    }
    if (multiSelect) {
      return "Select up to 10 accounts to view their consolidated statement.";
    }

    return "";
  }, [flow, TypeAccount, type]);

  const handleClosePopup = () => {
    setOpenOwner?.(false);
  };

  return (
    <LargePopupRedirect
      closeiconhandleFunction={handleClosePopup}
      isfullViewrequired={false}
      fullviewbtnText="Open in full view"
      fullviewhandleFunction={() => {
        handleClosePopup();
        navigate("/owner_account_dashboard/owner_accounts_view_all");
      }}
      fullviewicon={ICONS?.REDIRECT}
      isbottomSectionneed={false}
      headerTitle={headerTitle}
      headersubtext={headersubtext}
    >
      <OwnerAccViewAll
        typepop="popup"
        setOpenOwner={setOpenOwner}
        setIsNeft={setIsNeft}
        setIsImps={setIsImps}
        setIsRtgs={setIsRtgs}
        txnPayLoad={txnPayLoad}
        setTxnPayLoad={setTxnPayLoad}
        flow={
          flow === "ReimbursementRequestMultiFlow"
            ? "ReimbursementRequestMultiFlow"
            : "createTxn"
        }
        handleButtonClick={handleButtonClickToUse}
        BenEnableNextButton={BenEnableNextButton}
        owneraccountNumber={accountNumber}
        setownerAccountNumber={setAccountNumber}
        owneraccountnumberstate={accountnumberstate}
        setowneraccountnumberstate={setaccountnumberstate}
        multiSelect={multiSelect}
        onClosed={onClosed}
        setDefaultAccountNumber={setDefaultAccountNumber}
        TypeAccount={TypeAccount}
        owneraccountDefaultNumber={accountDefaultNumber}
        popType={popType}
        handlePopupClose={handlePopupClose}
        scheduleIntenralTxn={scheduleIntenralTxn}
        type={type}
        setpaymentBox={setpaymentBox}
        setRefactorAccDetail={setRefactorAccDetail}
        selectedLabelsCreate={selectedLabelsCreate}
        TypeRTGS={TypeRTGS}
        currentAccountDetails={currentAccountDetails}
      />
    </LargePopupRedirect>
  );
};

export default OwnerAccountPopUp;
